// extracted by mini-css-extract-plugin
module.exports = {"usps":"ProductUSPsLegacy_usps__78_Mt","list":"ProductUSPsLegacy_list__y_dlP"};